import axios from 'axios';
import { auth } from '../firebase/config';

export const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,// || 'https://fapi.iamadityasharma.pro/api/v1',
    headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
    },
    timeout: 30000 // 30 seconds timeout for all API requests
});

// Request interceptor to add token
api.interceptors.request.use(async (config) => {
    // We prioritize the backend token if it exists
    const token = localStorage.getItem('backendToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    } else {
        // Fallback or Initial Auth Call (e.g. /auth/login) might not need this if payload has idToken
        // But for safety, if no backend token, we check firebase user (only for /auth/login usually)
        // Actually, /auth/login takes idToken in body.
        // Other routes need backend token.
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
